import { render, staticRenderFns } from "./DialogAddMail.vue?vue&type=template&id=38be0a7e&scoped=true"
import script from "./DialogAddMail.vue?vue&type=script&lang=js"
export * from "./DialogAddMail.vue?vue&type=script&lang=js"
import style0 from "./DialogAddMail.vue?vue&type=style&index=0&id=38be0a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be0a7e",
  null
  
)

export default component.exports